export const urlBuilder = (
  serverUrl: string,
  queryParams: Record<string, string | number | boolean>,
  path = ''
): string => {
  const baseURL = new URL(`${serverUrl}${path ? '/' : ''}${path}`);
  for (const [key, val] of Object.entries(queryParams))
    if (key && val)
      baseURL.searchParams.append(key, val.toString());
  return baseURL.toString();
}
